import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { CompanyServices } from '../services/companyServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);

const items = [
    { id: 1, "societyName": "Society 1", "winbizFile": "File1234", "address": "1304 Lake Road, Hightstown", "postalCode": "08520", "noTVA": "-", "bankInfo": "Test Bank\nTest Payments, Inc.\nAccount number: 12983719830\nRouting number: 345834958\n" },
    { id: 1, "societyName": "Society 2", "winbizFile": "File1234", "address": "1304 Lake Road, Hightstown", "postalCode": "08520", "noTVA": "-", "bankInfo": "Test Bank\nTest Payments, Inc.\nAccount number: 12983719830\nRouting number: 345834958\n" },
    { id: 1, "societyName": "Society 3", "winbizFile": "File1234", "address": "1304 Lake Road, Hightstown", "postalCode": "08520", "noTVA": "-", "bankInfo": "Test Bank\nTest Payments, Inc.\nAccount number: 12983719830\nRouting number: 345834958\n" },
    { id: 1, "societyName": "Society 4", "winbizFile": "File1234", "address": "1304 Lake Road, Hightstown", "postalCode": "08520", "noTVA": "-", "bankInfo": "Test Bank\nTest Payments, Inc.\nAccount number: 12983719830\nRouting number: 345834958\n" },
    { id: 1, "societyName": "Society 5", "winbizFile": "File1234", "address": "1304 Lake Road, Hightstown", "postalCode": "08520", "noTVA": "-", "bankInfo": "Test Bank\nTest Payments, Inc.\nAccount number: 12983719830\nRouting number: 345834958\n" },
];

export default class CompaniesStore {    

    
  rootStore;
  companies = [];
    company = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,

          companies: observable,
          company: observable,
          getAll: action,
          getById:action,
          reset: action,
          save: action,
          remove: action,
          duplicate: action,
          searchCompany:action
      });

      makePersistable(this, { name: 'companiesStore', properties: ['config'], storage: window.localStorage });

    }       

    searchCompany = async (query) => {
        try {
            var result = CompanyServices.search(query);
            return result;
        }
        catch (error) {
            return [];
        }

    }

    remove = async (id) => {
        try {
            const data = await CompanyServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("company") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    duplicate = async (id) => {
        try {
            const data = await CompanyServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("company") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }


    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await CompanyServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("company") })}`);
                });
            } catch (error) { }
        } else {
            try {
                const data = await CompanyServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("company") })}`);
                    this.reset();
                });
            } catch (error) { }
        }
    };

    reset = () => {        
        runInAction(() => this.company = {});
    }

    setConfig = (prop, c) => { this.config[prop] = c; }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await CompanyServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.companies = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.companies = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await CompanyServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => { this.companies = data; })
        }
        catch (error) {
            runInAction(() => { this.companies = []; });
        }
    }

    getById = async (id) => {
        try {
            const data = await CompanyServices.getById(id);
            //data.ibansPerCurrency?.reduce((obj, item) => (obj[`iban_${item.currencyId}`] = item.iban, obj), {})
            runInAction(() => { this.company = data; });
        } catch (error) {
            runInAction(() => { this.company = {}; })
        }
    };
}